import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import CollectionView from "ToddleLibrary/components/CollectionView";
export default store => {
  return {
    path: "collections",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "toddle-library" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [CollectionView(store)],
  };
};
